import { TheraApiClient } from '@thera-hr/api-sdk';
import { TheraCheckFernSdkClient } from '@thera-hr/check-api-sdk';
import { useMemo } from 'react';

import { useUser } from 'context/user';
import { getCookie } from 'utils/cookie';

const apiBaseUrl = process.env.NEXT_PUBLIC_BACKEND_URL;
const checkBaseUrl = `${apiBaseUrl}/services/check`;

// Read the cookie per request. Stytch rotates the session JWT every few minutes, and a client
// built around the token value would be rebuilt on every rotation, re-running whatever depends on it.
const sessionToken = () => getCookie('stytch_session_jwt');

/**
 * Thera Fern API Client Hook
 * Note: Fern error extends standard Error object with body and statusCode properties
 */
export const useTheraFernClient = () => {
  const theraClient = useMemo(() => new TheraApiClient({ environment: apiBaseUrl, token: sessionToken }), []);

  return { theraFernApi: theraClient.api };
};

export const useCheckFernClient = () => {
  const { currentCompany, isLoading } = useUser() || {};
  const theraCompanyId = currentCompany?.companyID;

  // Memoize the client so consumers can safely depend on `checkFernApi`
  // without re-triggering effects on every render.
  const checkFernClient = useMemo(() => {
    if (!theraCompanyId) return null;
    return new TheraCheckFernSdkClient({ environment: checkBaseUrl, token: sessionToken, theraCompanyId });
  }, [theraCompanyId]);

  return { checkFernApi: checkFernClient, isLoading };
};
